import React from 'react';
import { getListingBillingBanner } from 'api/financials';
import { ListingBillingBannerVo } from 'types/financials';

// In-memory cache so the banner doesn't re-fetch on every layout remount.
let globalData: ListingBillingBannerVo | undefined;

const useListingFeeStatus = (): ListingBillingBannerVo | undefined => {
    const [data, setData] = React.useState<ListingBillingBannerVo | undefined>(globalData);

    const fetchData = async () => {
        try {
            const result = await getListingBillingBanner();
            if (!result.error) {
                const vo: ListingBillingBannerVo = result?.data?.data;
                globalData = vo;
                setData(vo);
            }
        } catch (e) {
            console.error(e);
        }
    };

    React.useEffect(() => {
        fetchData();
    }, []);

    return data;
};

export default useListingFeeStatus;
